/**
 * Converts a scale value to its corresponding slider value.
 */
type GetSliderFromScaleParams = {
  scale: number;
  minScale: number;
  sliderMax: number;
  maxScale: number;
  scaleAtCenter?: number; // Required for 'centered' mode
  sliderCenter?: number; // Required for 'centered' mode
  mode?: 'centered' | 'left';
};

export const getSliderFromScale = ({
  scale,
  minScale,
  sliderMax,
  maxScale,
  scaleAtCenter,
  sliderCenter,
  mode = 'centered',
}: GetSliderFromScaleParams) => {
  if (mode === 'left') {
    // Linear mapping from minScale to maxScale
    if (scale <= minScale) return 0;
    if (scale >= maxScale) return sliderMax;
    return Math.round(((scale - minScale) / (maxScale - minScale)) * sliderMax);
  } else {
    // Centered mapping: scaleAtCenter maps to sliderCenter
    if (typeof scaleAtCenter !== 'number' || typeof sliderCenter !== 'number') {
      throw new Error('scaleAtCenter and sliderCenter are required in centered mode');
    }
    if (scale === scaleAtCenter) return sliderCenter;
    if (scale < scaleAtCenter) {
      // Map values below center
      return Math.round(((scale - minScale) / (scaleAtCenter - minScale)) * sliderCenter);
    } else {
      // Map values above center
      return Math.round(
        ((scale - scaleAtCenter) / (maxScale - scaleAtCenter)) * (sliderMax - sliderCenter) + sliderCenter,
      );
    }
  }
};
